export const ALERT_SET = 'ALERT_SET'
export const ALERT_REMOVE = 'ALERT_REMOVE'
